@if (isEditMode === false) {
    <div>
        <div class="flex justify-content-between align-items-center gap-3 mb-3">
            <h2 class="section-title m-0">{{ 'settings.period.title' | translate }}</h2>
            @if (canAddPeriod) {
                <p-button
                    [label]="'settings.period.addYear' | translate"
                    icon="ms ms-add"
                    data-testid="settings-form-period-add-year-button"
                    (onClick)="openEditPeriod()" />
            }
        </div>
        <div class="card">
            <p-table [value]="existingPeriods" [loading]="isLoading" [showLoader]="false">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="period">
                            {{ 'components.settingList.period' | translate }}
                            <p-sortIcon field="period" />
                        </th>
                        @if (isOrgOwner) {
                            <th class="col-actions"></th>
                        }
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-period>
                    <tr>
                        <td class="font-medium">{{ period.period }}</td>
                        @if (isOrgOwner) {
                            <td class="col-actions">
                                <p-button
                                    icon="ms ms-edit"
                                    [text]="true"
                                    [rounded]="true"
                                    size="small"
                                    [ariaLabel]="'components.settingsForm.button.edit' | translate"
                                    [pTooltip]="'components.settingsForm.button.edit' | translate"
                                    (onClick)="openEditPeriod(period.period)" />
                            </td>
                        }
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    @for (row of [1, 2, 3]; track row) {
                        <tr>
                            <td><p-skeleton width="4rem" /></td>
                        </tr>
                    }
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="isOrgOwner ? 2 : 1">
                            <div class="empty-state empty-state--compact">{{ 'common.noData' | translate }}</div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
} @else {
    <app-edit-period
        [period]="selectedPeriod"
        [availableYears]="availableYears"
        [organizationId]="organizationId"
        [activeQuestionnaire]="activeQuestionnaire"
        [questionnaires]="questionnaires"
        (closeEditPeriod)="onCloseEditPeriod($event)"></app-edit-period>
}
